import "./App.css";
// import "./stylesheet/vars.css";
import { Box } from "./components/Box/Box";
import { GlobalStyle } from "./index.styled";
import { HelmetProvider, Helmet } from "react-helmet-async";
import { QuizProvider } from "./providers/QuizProvider/QuizProvider";
import { useEffect, useRef, useState } from "react";
import { QuizPublicInfo } from "./providers/QuizProvider/QuizContext";
import { useTranslation } from "react-i18next";
import { ContainerBox } from "./components/Box/Box.styled";
import { googleActionStart } from './utils/googleAnalyticsAction'
import { fbqActionStart } from './utils/fbqAnalyticsActions'

const apiBaseUrl = process.env.REACT_APP_BASE_URL;

const runScript = function (script: any): Promise<void> {
  return new Promise((resolve, reject) => {
    script.parentNode.removeChild(script);
    const newScript = document.createElement("script");

    if (script.src) {
      newScript.src = script.src;
      newScript.onload = () => resolve();
      newScript.onerror = () => reject(new Error(`Failed to load script: ${script.src}`));
    } else if (script.textContent) {
      newScript.textContent = script.textContent;
      // inline scripts are executed immediately when appended
      resolve();
    } else if (script.innerText) {
      newScript.innerText = script.innerText;
      resolve();
    }

    document.body.appendChild(newScript);
  });
};

type HeightId = ReturnType<typeof setTimeout>;


function App() {
  const { i18n } = useTranslation();
  const quizId = window.location.hostname.split(".")[0]

  const urlParams = new URLSearchParams(window.location.search);

  const [isNotIframe] = useState(() => window.self === window.top);
  const [session, setSession] = useState<string | null>(
    isNotIframe ? "" : urlParams.get("session")
  );
  const parentUrl = urlParams.get("parentUrl") ?? "*";
  const [quiz, setQuiz] = useState<QuizPublicInfo>({} as QuizPublicInfo);

  const [availableHeight, setAvailableHeight] = useState<number | null>(null)
  const setTimotId = useRef<HeightId>()

  function getAvailableHight() {
    const availableHeight = window.visualViewport?.height ?? null;

    setAvailableHeight(availableHeight)
  }


  useEffect(() => {
    if (isNotIframe) {
      (async () => {
        try {
          const localKey = `boostinglead-quiz-session-${quizId}`;
          const resp = await fetch(`${apiBaseUrl}/client-sessions/`, {
            method: "POST",
            body: JSON.stringify({ subdomain: quizId }),
            headers: { "Content-Type": "application/json" },
          });
          const result = await resp.json();

          setSession(result.session);
          if (result.session) {
            localStorage.setItem(localKey, result.session);
          }
        } catch (error) {
          console.error(error);
        }
      })();
    }

    clearTimeout(setTimotId.current)
    getAvailableHight()
    setTimotId.current = setTimeout(() => {
      getAvailableHight()
    }, 1000)
    
  }, [quizId, isNotIframe]);

  useEffect(() => {
    if (!isNotIframe) {
      window.onresize = () => {
        window.parent.postMessage(
          {
            type: "onresize",
            height: document.querySelector("#root > *")?.clientHeight,
          },
          parentUrl
        );
      };
      return () => {
        window.onresize = null;
      };
    }
  }, [parentUrl, isNotIframe]);

  useEffect(() => {
    // let lang = "en";
    // switch (quiz.language) {
    //   case 1:
    //     lang = "uk";
    //     break;
    //   case 2:
    //     lang = "en";
    //     break;
    //   case 3:
    //     lang = "ru";
    //     break;
    // }
    // quiz.language_code = lang;
    i18n.changeLanguage(quiz.language_code ?? "en");
  }, [i18n, quiz]);

  const isLoadConfig = useRef(false);
  useEffect(() => {
    (async () => {
      if (!session) return;
      const resp = await fetch(`${apiBaseUrl}/quiz_public/${session}/`);
      const result = await resp.json();
      setQuiz(result);

      if (!isNotIframe) {
        setTimeout(() => {
          window.parent.postMessage(
            {
              type: "onload",
              height: document.querySelector("#root > *")?.clientHeight,
            },
            parentUrl
          );
        }, 10);
      }
      if (!isLoadConfig.current) {
        setTimeout(async () => {
          isLoadConfig.current = true;
          let respConfig = (window as any)["boostingleadData"] ? (window as any)["boostingleadData"] : null

          if(!respConfig) {
            respConfig = await fetch(`${apiBaseUrl}/quiz_config_public/${session}/`);
            respConfig = await respConfig.json()
          }
          
          const { facebook_pixel_id, facebook_pixel_status,
            google_tag_manager_id, google_tag_manager_status,
            google_analytics_id, google_analytics_status,
            tiktok_id, tiktok_status } = respConfig;

          if (google_tag_manager_status && google_tag_manager_id) {
            /************** start set GTM ******************/

            if (!document.getElementById("gtm-script")) {
              (function (w: any, d, s, l:any, i) {
                w[l] = w[l] || [];
                w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                var f = d.getElementsByTagName(s)[0] as any, j = d.createElement(s) as HTMLScriptElement, dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = true;
                j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                j.id = "gtm-script";  // Додаємо унікальний ID, щоб запобігти дублюванню
                f.parentNode.insertBefore(j, f);
              })(window, document, 'script', 'dataLayer', google_tag_manager_id);
            }

            //************** end set GTM ******************/
          }

          if (google_analytics_status && google_analytics_id) {
            /************** start set GA ******************/

            if (!document.getElementById("ga-script")) {
              const ga = document.createElement('script');
              ga.async = true;
              ga.src = `https://www.googletagmanager.com/gtag/js?id=${google_analytics_id}`;
              ga.id = "ga-script";  // Додаємо унікальний ID, щоб запобігти дублюванню
              document.head.appendChild(ga);
          
              ga.onload = function () {
                (window as any)["dataLayer"] = (window as any)["dataLayer"] || [];
                const gtag: any = function () {
                  (window as any)["dataLayer"].push(arguments);
                }
                gtag('js', new Date());
                gtag('config', google_analytics_id);
                // Збираємо інформацію
                googleActionStart()
              };
            }
            //************** end set GA ******************/
          }

          if (facebook_pixel_status && facebook_pixel_id) {
            /************** start set FbPixel ******************/

            const fbPixel = document.createElement('scripts') as HTMLScriptElement;
            fbPixel.id = "fbPixel"
            fbPixel.innerText = `!function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '${facebook_pixel_id}');
            fbq('track', 'PageView');`;
            if (!document.getElementById("fbPixel")) {
              document.head.appendChild(fbPixel);
              var script = document.getElementById("fbPixel") as any;
              runScript(script).then(() => {
                fbqActionStart()
              })

            }

            //************** end set FbPixel ******************/
          }

          if (tiktok_status && tiktok_id) {
            /************** start set TikTok ******************/

            const tiktok = document.createElement('scripts') as HTMLScriptElement;
            tiktok.id = "tiktok"
            tiktok.innerText = `!function (w, d, t) {
              w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
            var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
            ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
              ttq.load('${tiktok_id}');
              ttq.page();
            }(window, document, 'ttq');`;
            if (!document.getElementById("tiktok")) {
              document.head.appendChild(tiktok);
              /*             (function (w: any, d: any, t: any) {
                            w.TiktokAnalyticsObject = t;
                            var ttq = w[t] = w[t] || [];
                            ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"],
                            ttq.setAndDefer = function (t: any, e: any) {
                                t[e] = function () {t.push([e].concat(Array.prototype.slice.call(arguments, 0)))}
                              };
                            for (var i = 0; i < ttq.methods.length; i++)
                              ttq.setAndDefer(ttq, ttq.methods[i]);
                            ttq.instance = function (t: any) {
                              for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++)ttq.setAndDefer(e, ttq.methods[n]); return e
                            },
                              ttq.load = function (e: any, n: any) {
                                var r = "https://analytics.tiktok.com/i18n/pixel/events.js", o = n && n.partner;
                                ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = r, ttq._t = ttq._t || {}, ttq._t[e] = +new Date, ttq._o = ttq._o || {}, ttq._o[e] = n || {};
                                n = document.createElement("script") as any;
                                //n.type = "text/javascript", 
                                n.async = !0, 
                                n.src = r + "?sdkid=" + e + "&lib=" + t;
                                e = document.getElementsByTagName("script")[0];
                                e.parentNode.insertBefore(n, e)
                              };
                            ttq.load(tiktok_id);
                            ttq.page();
                          } as any)(window, document, 'ttq'); */

              var scriptTiktok = document.getElementById("tiktok") as any;
              runScript(scriptTiktok)
            }

            //************** end set TikTok ******************/
          }
        }, 100)

       }
    })();
  }, [session, parentUrl, isNotIframe]);

  return (
    <HelmetProvider>
      <GlobalStyle fontName="Montserrat" />
      <Helmet>
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
        </style>
        {quiz.title ? <title>{quiz.title}</title> : null}
        <meta name="description" content={quiz.description ? quiz.description : 'boosting Lead app'} />
      </Helmet>
      <QuizProvider
        value={quiz}
        session={session ?? undefined}
      >
        {isNotIframe ? (
          <ContainerBox height={availableHeight}>
            <Box height={availableHeight} />
          </ContainerBox>
        ) : (
          <Box height={availableHeight} />
        )}
      </QuizProvider>
    </HelmetProvider>
  );
}

export default App;
